import { isFeatureEnabled } from 'owa-feature-flags';

export default function isInLazySearchExperiment(): boolean {
    return isFeatureEnabled('sea-lazy2') || isFeatureEnabled('sea-lazyccf2');
}
